module.exports = __webpack_public_path__ + "static/media/7.16341f9b.jpeg";